<template>
  <div class="answer">
    <!-- 活动标题 -->
    <div v-wechat-title='"每日一题"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-td' v-show='preloadingShow'></div>
    </transition>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName" :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback="getFollowQyStatus" :gameName="gameName"></Os>
    <div class='home-page'>
      <div class="header">
        <div class="icon"></div>
        <div class="info">
          <div class="has-login" v-if="userInfo && userInfo.role_id">
            <div class="account">{{ userInfo.account }}</div>
            <div :class="`server-name ${userInfo.account ? '' : 'channel-server-name'}`">
              <div class="server">{{ userInfo.server_name }}</div>
              <div class="name">{{ userInfo.role_name }}</div>
            </div>

          </div>
          <div class="no-login" v-else @click="changeLoginPopup(true)">请先登录</div>
        </div>
        <div class="right">
          <div class="login-btn"
            v-if="!((!userInfo.account && userInfo.role_id && !['android', 'ios'].includes(userInfo.os)) || (userInfo.account && userInfo.role_id && ['android', 'ios'].includes(userInfo.os)))"
            @click="changeLoginPopup(true)"></div>
          <div class="change-btn"
            v-if="userInfo.account && userInfo.role_id && ['android', 'ios'].includes(userInfo.os)"
            @click="changeOsPopup(true)"></div>
          <div class="cancel-btn"
            v-if="!userInfo.account && userInfo.role_id && !['android', 'ios'].includes(userInfo.os)"
            @click="changeLogoutPopup(true)"></div>
        </div>
      </div>
      <div class="title">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/tideng/answer/title.png" />
        </transition>
      </div>
      <div class="cat"></div>
      <div class="content-wrapper">
        <div class="content">
          <div class="question">
            {{ topicData.topic }}
            <!-- 请问五郎上一周吃了什么零食？请问五郎上一周吃了什么零食？请问五郎上一周吃了什么零食？ -->
          </div>
          <div class="input-wrapper">
            <div class="input">
              <input @blur="blur" ref="input" @focus="focus" type="text"
                :placeholder="`${activeInfo.correct_answer || '赶快填写答案，开启宝箱'}`" :disabled="!!activeInfo.correct_answer"
                v-model="inputValue">
            </div>
          </div>
          <!-- 查找答案 -->
          <div class="view" @click="onMove(topicData.url)"></div>
          <!-- 领奖记录 -->
          <div class="history-btn-wrapper">
            <div class="history-btn" @click="userInfo.os ? openPopup('rewardHistoryShow') : loginPopup()">
            </div>
          </div>
          <!-- 奖励列表预览 -->
          <div class="reward-list-wrapper">
            <div class="list-content-wrapper" ref="listWrapperRef">
              <div class="list-content" ref="listContentRef">
                <div :class="`list-item list-item${i}`" v-for="(i, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  :key="index">
                </div>
              </div>

            </div>
            <div class="left" @click="moveList('left')"></div>
            <div class="right" @click="moveList('right')"></div>
          </div>
          <div class="reward-down"></div>
        </div>
      </div>
      <div v-if="activeInfo.is_follow_qy" :class="`${activeInfo.is_answer ? 'has-reward-btn' : 'reward-btn'}`"
        @click="onRewardClick()"></div>
      <div class="no-follow-qy" v-else @click="clickShowQy"></div>
      <div class="rule"></div>
      <div class="white"></div>
    </div>

    <!-- 弹窗类 -->
    <div class="qy-wrap popup_wrap" v-show="qyShow">
      <div class="popup_wrap_box" v-show="qyShow" @click="closeQy">
          <div class="qy_box" v-show="qyShow">
            <img src="https://download4.qcplay.com/h5-images/active/tideng/answer/code.png" />
          </div>
        <div class="close-bg" v-show="qyShow" @click="closeQy"></div>
      </div>
    </div>
    <!-- 转盘 -->
    <div @touchmove.prevent class="turntable-wrap popup_wrap" v-show="turntableShow">
        <div class="turntable-box" v-show="turntableShow">
          <div class="content">
            <div class="turntable" title="转盘">
              <div class="pointer-1" ref="rotImg">
                <!-- <div :class="'spoonAni-' + spoonAniX"></div> -->
                <div :class="'spoonAni-false'"></div>
              </div>
            </div>
          </div>
          <div class="close-btn" @click="closePopup('turntableShow'); resetTurntable()"></div>
        </div>
    </div>
    <!-- 获取的奖励 -->
    <div class="reward_wrap popup_wrap" v-if="rewardShow">
        <div class="reward_box popup_wrap_box" v-show="rewardShow" @click="closePopup('rewardShow')">
          <div class="reward-content">
            <p>恭喜您获得了<span>{{ getRewardData.name }}</span>! </p>
            <p>奖励已经发至邮箱，请于游戏内查收~</p>
          </div>
        </div>
      <div class="close-bg" v-show="rewardShow" @click="closePopup('rewardShow')"></div>
    </div>

    <!-- 领奖记录 -->
    <div class="reward-history-wrap popup_wrap reward__history_wrap" v-show="rewardHistoryShow">
      <div class="history-content popup_wrap_box" v-show="rewardHistoryShow" @click="closePopup('rewardHistoryShow')">
          <div class="reward_history_box" v-show="rewardHistoryShow">
            <div class="reward-history-content">
              <div class="history-list">
                <p v-for="item in activeInfo.reward_record" :key="item.created_at">
                  <span>{{ item.created_at }}</span>
                  <span>获得<span class="reward-item">{{ item.remark }}</span></span>
                </p>
              </div>
            </div>
          </div>
      </div>
      <div class="close-bg" v-show="rewardHistoryShow" @click="closePopup('rewardHistoryShow')"></div>
    </div>

    <!-- 渠道账户注销弹窗 -->
    <div class="popup_wrap logout-confirm-wrap" v-show="logoutPopup">
        <div class="popup-wrap-box" v-show="logoutPopup">
          <div class="content">
            <p>确认注销当前用户？</p>
          </div>
          <div class="operation">
            <div @click.stop="changeLogoutPopup(false)">取消</div>
            <div @click.stop="confirmLogout()">确认</div>
          </div>
        </div>
      <div class="close-bg" v-show="logoutPopup" @click.stop="changeLogoutPopup(false)"></div>
    </div>

    <!-- 错误弹窗 -->
    <div class="error-wrap popup_wrap" v-show="errorShow">
      <div class="error-content popup_wrap_box" v-show="errorShow" @click="closePopup('errorShow')">
          <div class="error_box" v-show="errorShow">
          </div>
      </div>
      <div class="close-bg" v-show="errorShow" @click="closePopup('errorShow')"></div>
    </div>

    <!-- 未输入弹窗 -->
    <div class="no-answer popup_wrap" v-show="noAnswerShow">
      <div class="no-answer-content popup_wrap_box" v-show="noAnswerShow" @click="closePopup('noAnswerShow')">
          <div class="no_answer_box" v-show="noAnswerShow">
          </div>
      </div>
      <div class="close-bg" v-show="noAnswerShow" @click="closePopup('noAnswerShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { onGetInitDataAPI, onGetList, onAnswer } from '../api';
import { buriedLogger } from '@/utils/utils';
import { LogoutAPI } from "@/api/login";
export default {
  name: 'anniversary',
  components: {
    Header,
    Footer,
    Login,
    Os,
  },
  data() {
    return {
      qyShow: false,
      gameName: 'tideng',
      downloadUrl: 'https://static.qcplay.com/tideng/official/',
      preloadingShow: true,
      titleShow: true,
      shareImg: null,
      shareShow: false,
      preventShow: false,
      logger: null,
      // 业务弹窗
      detailShow: false,
      rewardShow: false,
      harvestCakeShow: false,
      lackTimesShow: false,
      coinAniShow: false,
      turntableShow: false,
      spoonAniX: false,
      logoutPopup: false,
      rewardHistoryShow: false,
      topicData: {
        topic: '',
        url: ''
      },
      inputValue: undefined,
      getRewardData: {
        name: '',
        reawrd_index: 0,
        reward_id: 0
      },
      index: 0,
      errorShow: false,
      noAnswerShow: false,
      timer: null
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    window.addEventListener('pageshow', this.resize)
    window.addEventListener('resize', this.resize)
    setTimeout(() => {
      Promise.all([onGetInitDataAPI(), onGetList()]).then(([initJson, answerJson]) => {
        if (initJson.code === 302) {
          window.location.href = 'https://api.qingcigame.com/wechat/oauth/?callback=' + encodeURI(window.location.href);
          return;
        }
        if (initJson.code !== 302) {
          this.topicData = answerJson.data.topic_list
          this.activeInfo.is_follow_qy = answerJson.data.is_follow_qy
        }
        this.onInitDataCallback(initJson);
        this.preloadingShow = false;
        if(initJson.data.activity) { 
          this.activeInfo.is_follow_qy = initJson.data.activity.is_follow_qy
        }
      }).finally(() => {
        Indicator.close()
      })
    }, 100);

    // 埋点
    const bl = buriedLogger('tideng', '每日一题_首页');
    this.logger = bl;

    this.setShare({
      title: '每日答题 奖励不停',
      desc: '《提灯与地下城》| 听说你超勇，超懂提灯的？那这道题肯定难不住你！快来把奖励拿回家吧',
      imgUrl: 'https://download4.qcplay.com/qcgame-admin/ijsUx8Brv1HZGSpqLtij6RLTyyIM7nF5tU0NM0ce.png'
    });
  },
  mounted() {
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.user_id) {
          // TAG: 注销的时候
          this.orderId = null;
          this.roleId = null;
          this.shareImg = null;
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          if (this.activeInfo.order && this.activeInfo.order.order_id) {
            this.orderId = this.activeInfo.order.order_id;
            this.roleId = this.activeInfo.order.data;
            this.showRole = true;
            this.aniStop = false;
          } else {
            this.orderId = null;
            this.roleId = null;
          }
        }
      }
    }
  },
  methods: {
    getFollowQyStatus() {
      onGetList().then(res => {
          if (Number(res.code) === 200) {
              this.$set(this.activeInfo,'is_follow_qy', res.data.is_follow_qy)
          }
      })
    },
    resize () {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
          let fontSize
          if (window.innerHeight > 950 && window.innerHeight < 965) {
            fontSize = '77px'
          }
          if (window.innerHeight > 966 && window.innerHeight < 1050) {
            fontSize = '84px'
          }
          if (window.innerHeight > 1050) {
            fontSize = '103px'
          }
          document.getElementsByTagName('html')[0].style.fontSize = fontSize
      })
    },
    focus() {//获取焦点的时候进行触发
      window.addEventListener('resize', () => {
        if (document.activeElement.tagName == 'INPUT') {
          window.setTimeout(() => {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 100);
        }
      })
    },
    blur() {//失去焦点的时候，进行触发
      var u = navigator.userAgent;
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {//安卓手机
        this.$refs.input.scrollIntoView(false);
      } else {
        window.scroll(0, 0);//苹果
      }
    },
    closeQy() {
      this.qyShow = false
      // 取消弹窗判断是否扫码了添加了企业微信
      setTimeout(() => {
        Promise.all([onGetInitDataAPI(), onGetList()]).then(([initJson, answerJson]) => {
          if (initJson.code === 302) {
            window.location.href = 'https://api.qingcigame.com/wechat/oauth/?callback=' + encodeURI(window.location.href);
            return;
          }
          if (initJson.code !== 302) {
            this.topicData = answerJson.data.topic_list
            this.activeInfo.is_follow_qy = answerJson.data.is_follow_qy
          }
          this.onInitDataCallback(initJson);
          if(initJson.data.activity) {
            this.activeInfo.is_follow_qy = initJson.data.activity.is_follow_qy
          }
        }).finally(() => {
          Indicator.close()
        })
      }, 100);
    },
    loginPopup() {
      // 未关注企业微信
      if (!this.activeInfo.is_follow_qy) {
        this.clickShowQy()
        return
      }
      this.changeLoginPopup(true);
    },
    clickShowQy() {
      if (!this.activeInfo.is_follow_qy) {
        this.qyShow = true
      }
    },
    // 选择角色后
    selectCallback(type) {
      type !== 'noClear' && (this.inputValue = undefined)
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },

    // 答完题之后
    afterAnswer() {
      onGetInitDataAPI().then(response => {
        if(Number(response.code) === 200) { 
           this.activeInfo.correct_answer = response.data.activity.correct_answer
           this.activeInfo.reward_record = response.data.activity.reward_record
           this.activeInfo.is_answer = response.data.activity.is_answer
           this.activeInfo.is_follow_qy = response.data.activity.is_follow_qy
        }
      });
    },

    // 【转盘】 打开转盘
    toDraw(index) {
      this.spoonAniX = false

      this.$nextTick(() => {
        this.rotate = this.setRotate(36 * index + 360 * 4)
        this.start()
      })

      this.preventShow = true; // 阻止点击穿透
    },

    // 【转盘】 计算装盘角度
    setRotate(deg) {
      let rest = deg - 360;
      return rest > 360 * 6 ? this.setRotate(rest) : deg;
    },
    // 【转盘】 勺子转动效果
    start() {
      console.log(this.rotate);
      this.$refs.rotImg.style.transition = 'all 3s ease 0s';
      this.$refs.rotImg.style.transform = 'rotate(' + this.rotate + 'deg)';
      setTimeout(() => {
        this.preventShow = false
      }, 3000)
    },

    // 【转盘】 重置转盘
    resetTurntable() {
      console.log(1111);
      this.rotate = 0;
      this.$refs.rotImg.style.transition = 'all 0s ease 0s';
      this.$refs.rotImg.style.transform = `rotate(0deg)`;
    },

    openPopup(name) {
      // 未关注企业微信
      if (!this.activeInfo.is_follow_qy) {
        this.clickShowQy()
        return
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 奖励列表移动
    moveList(type) {
      const width = this.$refs.listWrapperRef.clientWidth
      const left = this.$refs.listContentRef.scrollLeft
      this.$refs.listContentRef.scrollLeft = type === 'right' ? left + width : left - width
    },
    changeLogoutPopup(type) {
      this.logoutPopup = type
    },
    // 注销
    confirmLogout() {
      LogoutAPI({ game_id: this.userInfo.game_id }).then(response => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLogoutPopup(false);
          this.changeLoginPopup(true);  
        }
      });
    },
    onMove(href) {
      // 未关注企业微信
      if (!this.activeInfo.is_follow_qy) {
        this.clickShowQy()
        return
      }
      window.location.href = href
    },
    // 提交答案
    onRewardClick() {
      console.log(this.inputValue);
      if (!(this.userInfo.role_id)) return this.changeLoginPopup(true)
      if (this.activeInfo.is_answer) return
      if (!this.inputValue) return this.noAnswerShow = true
      Indicator.open()
      onAnswer({
        id: this.topicData.id,
        answer: this.inputValue
      }).then(res => {
        if (res.code === 200) {
          this.logger.sum('每日一题_参与答题');
          this.openPopup('turntableShow')
          this.getRewardData = res.data
          this.inputValue = undefined
          setTimeout(() => {
            this.toDraw(res.data.reawrd_index)
            this.afterAnswer()
            setTimeout(() => {
              this.openPopup('rewardShow')
              this.spoonAniX = true
            }, 4000);
          }, 200);
        } else {
          this.errorShow = true
        }
      }).catch((rej) => {
        // this.onToast(rej.message)
        this.logger.sum('每日一题_答题错误');
        this.errorShow = true
      }).finally(() => {
        Indicator.close()
      })
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setActiveInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
};
</script>

<style lang='less' scoped>
@import url('./index.less');
</style>

<style>
.mint-indicator {
  position: relative;
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/pages/tideng/answer/index/index.vue